<template>
  <nav id="sidebarMenu" class="sidebar">
    <h1 class="sidebar__title" href="/">Babyteca S.L.</h1>
    <div>
      <ul class="nav">
        <li class="nav-item" :class="selectedOption == 'SplitPayrolls' ? 'selected' : null" @click="selectItem('SplitPayrolls')">
          <router-link :to="{name: 'SplitPayrolls'}" class="nav-link">
            <ScissorsIcon  size="1x" />
            Separar nóminas
          </router-link>
        </li>
        <li class="nav-item" :class="selectedOption == 'SendPayrolls' ? 'selected' : null" @click="selectItem('SendPayrolls')">
          <router-link :to="{name: 'SendPayrolls'}" class="nav-link">
            <SendIcon size="1x" />
            Enviar nóminas
          </router-link>
          <q-badge v-if="pendingPayrolls.length > 0" color="primary" floating>{{ pendingPayrolls.length }}</q-badge>
        </li>
        <li class="nav-item" :class="selectedOption == 'ManagePayrolls' ? 'selected' : null" @click="selectItem('ManagePayrolls')">
          <router-link :to="{name: 'ManagePayrolls'}" class="nav-link">
            <FileTextIcon size="1x" />
            Gestionar nóminas
          </router-link>
        </li>
        <li class="nav-item" :class="selectedOption == 'ManageEmployees' ? 'selected' : null" @click="selectItem('ManageEmployees')">
          <router-link :to="{name: 'ManageEmployees'}" class="nav-link">
            <UserIcon size="1x" />
            Gestionar empleados
          </router-link>
        </li>
      </ul>
    </div>
    <a @click="onLogout()" class="nav-link sidebar__logout">
      <LogOutIcon size="1x" />
      Cerrar sesión
    </a>
  </nav>
</template>

<script>

import { mapState, mapActions } from 'vuex'
import router from '../router/index'
import { ScissorsIcon , SendIcon, FileTextIcon, UserIcon, LogOutIcon } from "vue-feather-icons"

export default {
  data() {
    return {
      selectedOption: 'SplitPayrolls'
    }
  },
  components: {
    ScissorsIcon,
    SendIcon,
    FileTextIcon,
    UserIcon,
    LogOutIcon
  },

  computed: {
    ...mapState('payrolls', [
      'pendingPayrolls'
    ])
  },

  methods: {
    ...mapActions('auth', [
      'logout'
    ]),
    async onLogout() {
      await this.logout()
      router.push('/login')
    },
    selectItem(id) {
      this.selectedOption = id
    }
  },

  async mounted () {
    this.selectedOption = router.currentRoute.name
  }
}
</script>
